'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSupplyTypeForInvCode = function getSupplyTypeForInvCode(tagOption) {
    var invCode = tagOption.invCode;

    var _ref = invCode.match(/-(w(?:ph|de|ta))-/) || [],
        _ref2 = (0, _slicedToArray3.default)(_ref, 2),
        shortKey = _ref2[1];

    switch (shortKey) {
        case 'wde':
            return 'web_desktop';
        case 'wta':
            return 'web_tablet';
        case 'wph':
            return 'web_phone';
        default:
            return undefined;
    }
};

var addSupplyType = function addSupplyType(tagOptions) {
    return {
        'aa-sch-supply_type': getSupplyTypeForInvCode(tagOptions)
    };
};

exports.default = [addSupplyType];
//# sourceMappingURL=keywords-modifiers.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/roc-plugin-ads-appnexus/lib/renderer/config/keywords-modifiers.js
 ** module id = 554
 ** module chunks = 1
 **/